"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UI = void 0;
const mobx_react_1 = require("mobx-react");
const React = __importStar(require("react"));
const db_1 = require("./db");
const mobx_1 = require("mobx");
const async_1 = __importDefault(require("react-select/async"));
const debounce_promise_1 = __importDefault(require("debounce-promise"));
const factory_1 = __importDefault(require("react-plotly.js/factory"));
const core_1 = __importDefault(require("plotly.js/lib/core"));
const Plot = (0, factory_1.default)(core_1.default);
function formatDuration(sec_num) {
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - hours * 3600) / 60);
    const seconds = Math.round(sec_num - hours * 3600 - minutes * 60);
    return (String(hours).padStart(2, "0") +
        ":" +
        String(minutes).padStart(2, "0") +
        ":" +
        String(seconds).padStart(2, "0"));
}
const SponsorPlot = (0, mobx_react_1.observer)((p) => {
    return (React.createElement(Plot, { style: { width: "100%", maxWidth: "1200px", margin: "0 auto" }, onClick: (e) => {
            console.log("hover", e);
            const element = p.data[e.points[0].pointIndex];
            if (element)
                p.onHover(element);
        }, data: [
            {
                x: p.data.map((e) => new Date(e.meta.published * 1000)),
                y: p.data.map((e) => e.percentSponsor / 100),
                text: p.data.map((e) => `<b>${e.meta.title}</b><br>
              published ${new Date(e.meta.published * 1000).toLocaleDateString()}<br>
              Length: ${formatDuration(e.meta.lengthSeconds)}<br>
              Sponsor duration: ${formatDuration(e.durationSponsor)} (<b>${e.percentSponsor.toFixed(0)}%</b>)`),
                hovertemplate: "%{text}",
                type: "scatter",
                mode: "markers",
            },
        ], layout: {
            autosize: true,
            yaxis: { tickformat: ",.0%", title: "Part that is Sponsorship" },
            xaxis: { title: "Upload date" },
        } }));
});
function formatBytes(b) {
    if (b > 1e6) {
        return (b / 1e6).toFixed(2) + "MB";
    }
    if (b > 1e3) {
        return (b / 1e3).toFixed(2) + "KB";
    }
    return b + "B";
}
const SqliteStats = (0, mobx_react_1.observer)(({ stats, lastUpdated }) => {
    return (React.createElement(React.Fragment, null,
        "Sqlite stats: fetched ",
        formatBytes(stats.totalFetchedBytes),
        " in",
        " ",
        stats.totalRequests,
        " requests (DB size: ",
        formatBytes(stats.totalBytes),
        ", updated: ",
        new Date(lastUpdated * 1000).toLocaleDateString(),
        ")"));
});
const VideoMetaDisplay = (0, mobx_react_1.observer)(({ video }) => {
    return (React.createElement("div", null,
        React.createElement("a", { href: `https://youtube.com/watch?v=${video.meta.videoID}` },
            React.createElement("img", { src: video.meta.maxresdefault_thumbnail, width: 200, style: { float: "left", margin: "0.5em" } }),
            React.createElement("h4", null, video.meta.title)),
        video.meta.viewCount,
        " views",
        React.createElement("br", null),
        "published ",
        new Date(video.meta.published * 1000).toLocaleDateString(),
        React.createElement("br", null),
        "Length: ",
        formatDuration(video.meta.lengthSeconds),
        React.createElement("br", null),
        "Sponsor duration: ",
        formatDuration(video.durationSponsor),
        " (",
        React.createElement("b", null,
            video.percentSponsor.toFixed(0),
            "%"),
        ")"));
});
let UI = class UI extends React.Component {
    constructor(p) {
        super(p);
        this.worker = null;
        this.db = null;
        this.initState = "Loading...";
        this.data = {
            state: "noinput",
        };
        this.stats = null;
        this.dbConfig = null;
        this.focussedVideo = null;
        this.searchInput = "";
        this.interval = 0;
        this.authorsSearchDebounce = (0, debounce_promise_1.default)(this.authorsSearch.bind(this), 250, {
            leading: true,
        });
        this.setFocussed = (e) => (this.focussedVideo = e);
        this.init();
        (0, mobx_1.makeObservable)(this);
    }
    componentDidMount() {
        this.interval = setInterval(async () => {
            this.stats = (await this.worker?.getStats()) || null;
        }, 1000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    async init() {
        this.initState = "connecting to sqlite httpvfs database...";
        try {
            const res = await (0, db_1.createDbWorker)();
            this.db = res.db;
            this.worker = res.worker;
            this.dbConfig = res.config;
        }
        catch (e) {
            console.error(e);
            this.initState = `Error connecting to database: ${e}`;
            return;
        }
        const initialAuthor = new URLSearchParams(location.search).get("uploader");
        if (initialAuthor)
            this.setAuthor(initialAuthor);
        this.initState = "";
    }
    async setAuthor(search) {
        this.searchInput = search;
        this.focussedVideo = null;
        if (this.db) {
            this.data = {
                state: "loading",
                author: search,
            };
            this.data = {
                state: "loaded",
                author: search,
                segs: await (0, db_1.getForAuthor)(this.db, search),
            };
            console.log("data", this.data);
            {
                const searchParams = new URLSearchParams(location.search);
                searchParams.set("uploader", search);
                window.history.replaceState(null, document.title, "?" + searchParams);
            }
        }
    }
    async authorsSearch(search) {
        if (this.db) {
            return await (0, db_1.authorsSearch)(this.db, search);
        }
        return [];
    }
    render() {
        if (this.initState)
            return React.createElement("div", null, this.initState);
        return (React.createElement("div", null,
            React.createElement("div", null,
                "Search for YouTuber:",
                " ",
                React.createElement(async_1.default, { cacheOptions: true, inputValue: this.searchInput, onInputChange: (e) => (this.searchInput = e), loadOptions: this.authorsSearchDebounce, getOptionLabel: (e) => e.name, getOptionValue: (e) => e.name, onChange: (e) => e && this.setAuthor(e.name) })),
            this.data.state === "noinput" ? (React.createElement(React.Fragment, null)) : this.data.state === "loading" ? (React.createElement("div", null,
                "Loading videos for author \"",
                this.data.author,
                "\"")) : (React.createElement("div", null,
                React.createElement("p", null,
                    "Found ",
                    this.data.segs.length,
                    " videos with sponsorships from",
                    " ",
                    this.data.author),
                " ",
                React.createElement(SponsorPlot, { data: this.data.segs, onHover: this.setFocussed }))),
            this.focussedVideo && (React.createElement(React.Fragment, null,
                "Selected video: ",
                React.createElement(VideoMetaDisplay, { video: this.focussedVideo }))),
            React.createElement("footer", { style: { marginTop: "5em", color: "gray" } },
                React.createElement("div", null,
                    this.stats ? (React.createElement(SqliteStats, { stats: this.stats, lastUpdated: this.dbConfig.lastUpdated })) : (""),
                    " "),
                React.createElement("div", null,
                    "Source Code:",
                    " ",
                    React.createElement("a", { href: "https://github.com/phiresky/youtube-sponsorship-stats/" }, "https://github.com/phiresky/youtube-sponsorship-stats/")))));
    }
};
__decorate([
    mobx_1.observable
], UI.prototype, "initState", void 0);
__decorate([
    mobx_1.observable
], UI.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], UI.prototype, "stats", void 0);
__decorate([
    mobx_1.observable
], UI.prototype, "dbConfig", void 0);
__decorate([
    mobx_1.observable
], UI.prototype, "focussedVideo", void 0);
__decorate([
    mobx_1.observable
], UI.prototype, "searchInput", void 0);
__decorate([
    mobx_1.action
], UI.prototype, "setFocussed", void 0);
UI = __decorate([
    mobx_react_1.observer
], UI);
exports.UI = UI;
